import PropTypes from 'prop-types';
import React from 'react';

// Polyfill webpack require.ensure.
if (typeof require.ensure !== `function`) require.ensure = (d, c) => c(require);

const ImageAttachment = ({ dimensions, size, url, ...props }) => {
  const width = dimensions && dimensions[size] ? dimensions[size].width : null;
  const height =
    dimensions && dimensions[size] ? dimensions[size].height : null;
  return (
    <div
      className="attachment attachment--image"
      style={{
        width: width + 'px',
        maxWidth: '100%',
        backgroundImage: `url(${props.tiny_url})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
      }}
    >
      <a
        className="d-b"
        style={{
          position: 'relative',
          paddingBottom: width && height ? (height / width) * 100 + '%' : null,
          maxWidth: '100%',
          width: width + 'px',
        }}
        onClick={e => {
          e.preventDefault();
          import('../../../vendor/jquery.magnific-popup').then(() => {
            $.magnificPopup.open({
              items: { src: url },
              type: 'image',
              mainClass: 'animated fadeIn',
            });
          });
        }}
        href={size ? props[`${size}_url`] : url}
      >
        <img
          alt=""
          src={size ? props[`${size}_url`] : url}
          style={{
            cursor: 'pointer',
            maxWidth: '100%',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
          }}
          width={width}
        />
      </a>
    </div>
  );
};

ImageAttachment.propTypes = {
  dimensions: PropTypes.object,
  size: PropTypes.string,
  tiny_url: PropTypes.string,
  url: PropTypes.string.isRequired,
};

ImageAttachment.defaultProps = { size: 'thumb' };

export default ImageAttachment;
